import { formatCompactNumber } from '@insta-club/utilities';
import Image from 'next/image';
import { EyeIcon, HeartIcon, ReelsVideoIcon, ReelVideoIcon } from 'src/libs/components/icons';
import { Reel } from 'src/libs/models/explore.model';

function ExploreItem({ item, onClick }: { item: Reel; onClick?: (item: Reel) => void }) {
    const icon =
        item.items?.length > 1 ? (
            <ReelsVideoIcon width={20} height={20} className='text-white' />
        ) : item.items?.some((x) => x.type === 'video') ? (
            <ReelVideoIcon width={20} height={20} className='text-white' />
        ) : null;

    return (
        <div
            dir='rtl'
            className='group relative aspect-square h-full w-full cursor-pointer overflow-hidden rounded-2xl'
            onClick={() => onClick?.(item)}
        >
            <div className='absolute end-0 top-0 z-10 p-2'>
                <span className='shadow-sm'>{icon}</span>
            </div>

            <Image
                fill
                src={item?.thumbnail ?? '/img-not-found-placeholder.jpg'}
                alt={item?.caption ?? 'explore item'}
                className='object-cover'
            />

            <div className='absolute inset-0 bg-black/50 opacity-0 transition-opacity duration-300 ease-in-out group-hover:opacity-100'>
                <div className='flex h-full w-full items-center justify-center gap-4'>
                    <div className='flex items-center gap-1 text-white'>
                        <h4>{formatCompactNumber(1000000000)}</h4>
                        <EyeIcon />
                    </div>
                    <div className='flex items-center gap-1 text-white'>
                        <h4>{formatCompactNumber(3000)}</h4>
                        <HeartIcon />
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ExploreItem;

